var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("canvas", {
    directives: [
      {
        name: "show",
        rawName: "v-show",
        value: _vm.showCanvas,
        expression: "showCanvas",
      },
    ],
    ref: "canvas",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }